import { BettyBundle } from "shared/src/types/EvaluateArticleNew";

/**
 * This sorts the bundle selector by bundle name ascending and filters out bundles from that are not customer searchable
 * and not currently selected. When bundles are viewable, but not searchable, that means customers should be able to see
 * them when they have them e.g. on a list, but should not be able to select them in the bundle selector.
 *
 * Originally from articlesearch-ui/src/app/utils/articleUtils.ts as used in the old article card component.
 */
export function sortBundleSelectorAndFilterNonSearchableBundles(
    bundles?: Record<string, BettyBundle>,
    bundleSelector?: Record<string, string>,
    selectedStore?: string | undefined | null,
    selectedBundleId?: string | undefined | null,
    isFsdShop?: boolean,
    isMarioCountry?: boolean,
    isEmployee?: boolean
): Record<string, string> {
    const filteredBundleSelector: Record<string, string> = {};
    for (const bundleId of Object.keys(bundleSelector || {}).sort()) {
        const bundle = bundles![bundleId];
        const store = (selectedStore && bundle && bundle.stores && bundle.stores[selectedStore]) || null;
        let searchable = store && (store.customerSearchable || store.anonymousSearchable);
        // HACK: In countries like PT, we may get bundles that appear searchable because they are searchable for
        // STORE/STORE when using the full assortment, but we only want to show the FSD assortment. Ideally, this would
        // be handled by the search service because it knows which assortment we're looking for (the UI currently
        // doesn't have access to the `restrictShopAssortmentToFsd` flag). Since we can't do that yet, this is a hack to
        // hide those bundles; the hope is that !isMarioCountry matches up with restrictShopAssortmentToFsd (it
        // currently does).
        if (
            (!isMarioCountry || isFsdShop)
        ) {
            const fulfillmentTypes = store?.possibleDeliveryModes?.METRO_DELIVERY?.possibleFulfillmentTypes;
            const validFulfillmentTypes = ['FSD', 'TRADER', 'TRADER_FRANCHISE'];
            
            if (!fulfillmentTypes || !validFulfillmentTypes.some(type => fulfillmentTypes[type])) {
                searchable = false;
            }
        }
        const allowed = bundle.bundleId?.bettyBundleId === selectedBundleId || isEmployee || searchable;
        if (allowed) {
            filteredBundleSelector[bundleId] = bundleSelector![bundleId];
        }
    }
    return filteredBundleSelector;
}
